import { render, staticRenderFns } from "./comicControlls.vue?vue&type=template&id=0e6a926f&"
import script from "./comicControlls.vue?vue&type=script&lang=js&"
export * from "./comicControlls.vue?vue&type=script&lang=js&"
import style0 from "./comicControlls.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports